import { useState } from 'react';
import { Box, ButtonBase, InputBase, makeStyles } from '@material-ui/core';
import { isFunction } from 'lodash';
import { i18n } from '../../language';
import Text from '../Text';
import { CloseIcon } from '../Icon';
import { getUUID } from '../../utils';

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#7d86a9',
  },
  inputBase: ({ error }) => ({
    border: error ? 'solid 1px #f44336' : 'solid 1px #e4e7eb',
    borderRadius: '10px',
    minHeight: '3.5rem',
    width: '100%',
    padding: '0.56rem 0.62rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
    flexWrap: 'wrap',
    '& .MuiInputBase-input': {
      width: 'auto',
      flex: 1,
    },
  }),
  errorMsg: {
    color: '#f44336',
    margin: '0 0.5rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
  closeIcon: {
    fontSize: '0.8rem',
    color: '#ffffff',
  },
}));

const MultipleInput = ({
  title,
  placeholder,
  flexBasis,
  endAdornment,
  handleEnter,
  onFocus,
  onBlur,
  length = 'unset',
  error,
  errorMsg,
  readOnly = false,
  id,
  value = [],
  handleDelete,
}) => {
  const classes = useStyles({ error });
  const [inputValue, setInputValue] = useState('');

  const inputHandler = (event) => {
    setInputValue(event.target.value);
  };

  const onKeyDownHandler = (event) => {
    if ((event.code === 'Enter' || event.code === 'NumpadEnter') && isFunction(handleEnter)) {
      handleEnter({ value: event.target.value, id: getUUID() });
      setInputValue('');
    }
  };

  return (
    <Box display="flex" flexDirection="column" flexBasis={flexBasis} gridGap="1rem">
      {title && <div className={classes.title}>{title}</div>}
      <InputBase
        id={id}
        className={classes.inputBase}
        placeholder={placeholder}
        onChange={inputHandler}
        value={inputValue}
        endAdornment={endAdornment}
        onKeyDown={onKeyDownHandler}
        onFocus={onFocus}
        onBlur={onBlur}
        inputProps={{ maxLength: length }}
        readOnly={readOnly}
        startAdornment={<SelectedItems value={value} handleDelete={handleDelete} />}
      />
      {error && <div className={classes.errorMsg}>{i18n.t(errorMsg)}</div>}
    </Box>
  );
};

const SelectedItems = ({ value, handleDelete }) => {
  const classes = useStyles();
  return (
    <Box display="flex" gridGap="0.62rem" flexWrap="wrap" pr="0.62rem">
      {value.map((item) => (
        <Box
          display="flex"
          alignItems="center"
          borderRadius="0.625rem"
          border="1px solid #538FFF"
          bgcolor="#F5FAFF"
          height="2.375rem"
          pl="0.62rem"
          pr="0.62rem"
          gridGap="0.62rem"
          key={item.id}
        >
          <Text fontSize="1rem" color="#2E4469">
            {item.value}
          </Text>
          <ButtonBase>
            <Box
              width="1.375rem"
              height="1.375rem"
              borderRadius="50%"
              bgcolor="#538FFF"
              display="flex"
              alignItems="center"
              justifyContent="center"
              onClick={() => handleDelete(item.id)}
            >
              <CloseIcon className={classes.closeIcon} />
            </Box>
          </ButtonBase>
        </Box>
      ))}
    </Box>
  );
};

export default MultipleInput;
